"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateStatus = void 0;
var offer_1 = require("@src/constants/offer");
var translateStatus = function translateStatus(statusCode, t) {
    return t("erpapp.portal.offer.status." + (statusCode !== null && statusCode !== void 0 ? statusCode : offer_1.OFFER.STATUS_CODE.DRAFT) + ".text");
};
exports.translateStatus = translateStatus;
